import '../../CommonStyles.scss';
import { Loader } from '@trackman/web-shared-components';
import KpiCard from '../../components/KpiCard/KpiCard';
import { KpiDelta, KpiMeta } from '../../components/KpiMeta/KpiMeta';
import { useGetCertificationUserCounts, useGetActiveSubscriptionsKpi, useGetMasterCertifiedCount } from 'queryHooks/Admin/analytics';

export const OverviewTab = () => {
  const { data: certUserCounts, isLoading: certCountsLoading } = useGetCertificationUserCounts();
  const { data: activeSubsKpi, isLoading: activeSubsLoading } = useGetActiveSubscriptionsKpi();
  const { data: masterCertifiedCount, isLoading: masterCertifiedCountLoading } = useGetMasterCertifiedCount();

  return (
    <div className='analytics-tab'>
      {certCountsLoading || activeSubsLoading || masterCertifiedCountLoading ? (
        <div className='no-data'>
          <Loader size='large' />
        </div>
      ) : (
        <>
          <div className='overview-section'>
            <div className='section-grid metrics'>
              <ActiveSubscriptionsCard activeSubsKpi={activeSubsKpi} />
              <AutoRenewOnCard activeSubsKpi={activeSubsKpi} />
              <MasterCertifiedCard masterCertifiedCount={masterCertifiedCount} />
            </div>
          </div>

          <div className='overview-section'>
            <div className='section-grid metrics'>
              {certUserCounts?.map((c) => (
                <KpiCard key={c.certificationId} label={c.title} sources={['DB']} value={c.userCount} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const ActiveSubscriptionsCard = ({ activeSubsKpi }) => {
  return (
    <KpiCard label='Active Subscriptions' sources={['RECURLY']} value={activeSubsKpi?.activeSubscriptions ?? '—'}>
      {activeSubsKpi?.changePercent != null && <KpiDelta value={activeSubsKpi.changePercent} suffix='vs prev month' />}
    </KpiCard>
  );
};

const AutoRenewOnCard = ({ activeSubsKpi }) => {
  return (
    <KpiCard label='Auto-Renew ON' sources={['RECURLY']} value={activeSubsKpi?.renewingSubscriptions ?? '—'}>
      {activeSubsKpi?.renewingSubscriptionsPercent != null && (
        <KpiMeta tone='positive'>{activeSubsKpi.renewingSubscriptionsPercent.toFixed(1)}% of active</KpiMeta>
      )}
    </KpiCard>
  );
};

const MasterCertifiedCard = ({ masterCertifiedCount }) => {
  return <KpiCard label='Master Certified' sources={['DB']} value={masterCertifiedCount ?? '—'}></KpiCard>;
};

export default OverviewTab;
